{
  "title": "Daylight",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level evocation",
  "level": 3,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "1 hour",
  "description": [
    "A 60-foot-radius sphere of light spreads out from a point you choose within range. The sphere is bright light and sheds dim light for an additional 60 feet.",
    "If you chose a point on an object you are holding or one that isn’t being worn or carried, the light shines from the object with and moves with it. Completely covering the affected object with an opaque object, such as a bowl or a helm, blocks the light.",
    "If any of this spell’s area overlaps with an area of darkness created by a spell of 3rd level or lower, the spell that created the darkness is dispelled."
  ],
  "spellLists": ["cleric", "druid", "paladin", "ranger", "sorcerer"]
}
